<template>
  <div>
      <!-- banner -->
      <div class="banner-box">
        <a-carousel class="banner-swiper" autoplay :radius-dot='false' :autoplay-speed='5000' arrow='never'>
          <div class="carouse-tem">
            <div class="carouse-tem fbox fbox-ac">
              <div class="title">一体化教学、<br>实训实践方案解决商</div>
            </div>
          </div>
          <div class="carouse-tem">
            <div class="carouse-tem fbox fbox-ac">
              <div class="title">完整、标准化的教学资源，<br>从0到1升级师资力量</div>
            </div>
          </div>
          <!-- <div class="carouse-tem">
            <div class="carouse-tem fbox fbox-ac">
              <div class="title">3步搭建专属独立网校，<br>满足在线教学需求</div>
            </div>
          </div> -->
        </a-carousel>
        <!-- <a-carousel class="banner-swiper" :autoplay="true" :dots="false">
          <div>
            <div class="carouse-tem fbox fbox-ac">
              <div class="title">一体化教学、<br>实训实践方案解决商</div>
            </div>
          </div>
          <div>
              <div class="carouse-tem fbox fbox-ac">
                <div class="title">完整、标准化的教学资源，<br>从0到1升级师资力量</div>
              </div>
          </div>
          <div>
            <div class="carouse-tem fbox fbox-ac">
              <div class="title">3步搭建专属独立网校，<br>满足在线教学需求</div>
            </div>
          </div>
        </a-carousel> -->
        <div class="login-box fbox fbox-jb fbox-ac w fbox-w">
          <Login v-if="!$store.state.user" class="login"  />
        </div>
        <div class="login-btn" v-if="!$store.state.user">
          <div @click="login">登录</div>
          <div @click="register">注册</div>
        </div>
      </div>
      <!-- 3大选课 -->
      <div class="model contener">
        <!-- 标题 -->
        <div class="title color-black">
          <h2 class="font-weight-b">3大选课模式，课程自主化</h2>
          <p>CURRICULUM&nbsp;&nbsp;AUTONOMY</p>
        </div>
        <Row class="tab-box w">
          <Col class="tab-pc" :xs="24" :sm="24" :md="8" :lg="9">
            <div class="left-tab fbox fbox-ac fbox-ja" v-for="(item, index) in TabList" :key="index" :class="{tabActiveClass: tabIndex == index}" @mouseover="mouseOver(index)">
              <div class="fbox fbox-ac fg1">
                <p class="number fsh">{{item.number}}</p>
                <p class="fg1 ell">{{item.titles}}</p>
              </div>
              <img class="fsh" :src="tabIndex == index?activeImg:noneImg" alt="">
            </div>
          </Col>
          <Col class="tab-ph" :xs="24" :sm="24" :md="24" :lg="24">
            <Row class="" type="flex" justify="space-between">
              <div class="ph-left-tab ell tc" v-for="(item, index) in TabList" :key="index" :class="{tabActiveClass: tabIndex == index}" @mouseover="mouseOver(index)">
                  {{item.titles}}
              </div>
            </Row>
          </Col>
          <Col class="right-tab" :xs="24" :sm="24" :md="16" :lg="13">
            <h3 class="font-weight-b">{{TabList[tabIndex].titles}}</h3>
            <p>{{TabList[tabIndex].content}}</p>
            <img :src="TabList[tabIndex].img">
          </Col>
        </Row>
      </div>
      <!-- 企业讲师 -->
      <div class="teacher-contener contener">
        <!-- 标题 -->
        <div class="title">
          <h2 class="font-weight-b">企业讲师</h2>
          <p>CORPORATE&nbsp;&nbsp;LECTURER</p>
        </div>
        <!-- 讲师轮播 -->
        <div class="w">
          <TeacherSlide @changeSlide="changeSlide($event)" :sliders='teacher' v-if="teacher.length" />
        </div>
      </div>

      <div class="contener">
        <!-- 标题 -->
        <div class="title">
          <h2 class="font-weight-b">合作院校</h2>
          <p>CURRICULUM&nbsp;&nbsp;AUTONOMY</p>
        </div>
        <!-- 院校轮播 -->
        <div class="w">
          <SchoolSlide :imgList='logos' />
        </div>
        <!-- 简介 -->
        <Row class="school w">
          <Col class="tc" v-for="(item, index) in school" :key="index" :xs="8" :sm="8" :md="4" :lg="4">
            <div class="img-box fbox fbox-jc">
              <img :src="item.img" :style="{ width: item.width, height: item.height }">
            </div>
            <div class="color-black font-weight-b"><span class="">{{item.num}}</span>{{item.unit}}</div>
            <p class="color-gray">{{item.content}}</p>
          </Col>
        </Row>
      </div>
  </div>
</template>

<script>
import Login from '@/components/login'
import SchoolSlide from '@/components/schoolSlide'
import TeacherSlide from '@/components/teacherSlide'

export default {
  name: 'index',
  components: {
    Login,
    SchoolSlide,
    TeacherSlide
  },
  data () {
    return {
      value1: 0,
      TabList: [
        {
          number: '01',
          titles: '专业选课',
          content: '资深教学团队打造标准化教学模式，线上线下教学资源融合教学。',
          img: 'https://qingbo-oss.oss-cn-beijing.aliyuncs.com/03ac93df-32c5-496c-adb2-2219cf596ab8.png'
        },
        {
          number: '02',
          titles: '自定义选课',
          content: '课程体系个性化定制，院校灵活掌握专业发展方向。',
          img: 'https://qingbo-oss.oss-cn-beijing.aliyuncs.com/c6c0d8b7-1600-4993-82d9-44946548f9e9.png'
        },
        {
          number: '03',
          titles: '岗位选课',
          content: '岗位选择对应课程，以市场需求为导向制定专属专业课程。',
          img: 'https://qingbo-oss.oss-cn-beijing.aliyuncs.com/2b76bccb-fc6b-4c3c-82d1-b63c97c01f96.png'
        }
      ],
      tabIndex: 0,
      activeImg: 'https://qingbo-oss.oss-cn-beijing.aliyuncs.com/482a3b44-82fc-4dbf-aaab-3ce0ef89d3c7.png', // 选中箭头
      noneImg: 'https://qingbo-oss.oss-cn-beijing.aliyuncs.com/d9620aab-18f4-4b28-bd9d-8628e6bf87f3.png', // 未选中箭头
      value3: 0,
      setting: {
        autoplay: false,
        autoplaySpeed: 2000,
        dots: 'inside',
        radiusDot: false,
        trigger: 'click',
        arrow: 'always'
      },
      logos: [],
      school: [
        { img: 'https://qingbo-oss.oss-cn-beijing.aliyuncs.com/7e094457-cad4-485f-9291-311924e98587.png', num: 13, unit: '大', content: '专业岗位领域', width: '54px', height: '58px' },
        { img: 'https://qingbo-oss.oss-cn-beijing.aliyuncs.com/3412dd6b-36a0-468a-97d5-77cfc2b67167.png', num: 186, unit: '套', content: '专业课程', width: '49px', height: '53px' },
        { img: 'https://qingbo-oss.oss-cn-beijing.aliyuncs.com/f990cef2-71d2-47bf-adc8-bdf4c30f3799.png', num: 12, unit: '万', content: '音视频课程', width: '55px', height: '50px' },
        { img: 'https://qingbo-oss.oss-cn-beijing.aliyuncs.com/30598eec-74e1-4b82-8f67-5532fd7a245d.png', num: 100, unit: '+', content: '合作院校', width: '55px', height: '50px' },
        { img: 'https://qingbo-oss.oss-cn-beijing.aliyuncs.com/1861252b-c05b-4652-afbd-e63fc130d9e1.png', num: 60, unit: '+', content: '位授课名师', width: '54px', height: '55px' },
        { img: 'https://qingbo-oss.oss-cn-beijing.aliyuncs.com/6a551212-991d-48f4-a7f8-cc3ae6296562.png', num: 6, unit: '万+', content: '注册学生', width: '67px', height: '50px' }
      ],
      Item: null,
      teacher: []
    }
  },
  mounted () {
    this.init()
    console.log('---')
  },
  methods: {
    // 请求初始化
    async init () {
      await this.getTeacherSlide()
      await this.getSchoolSlide()
    },
    async getTeacherSlide () {
      // 获取老师
      let res = await this.$tkParse.getList('/classes/webTeacher', {
        params: {
          order: 'ranking, -createdAt'
        }
      })
      res.forEach(item => {
        if (item.honor && item.honor.length > 3) {
          item.honor = item.honor.slice(0, 3)
        }
        if (item.lable && item.lable.length > 2) {
          item.lable = item.lable.slice(0, 2)
        }
      })
      this.teacher = res
    },
    async getSchoolSlide () {
      // 获取院校
      let res = await this.$tkParse.getList('/classes/webSchool', {
        params: {
          order: 'ranking, -createdAt'
        }
      })
      this.logos = res
    },
    // tab切换事件
    mouseOver (index) {
      this.tabIndex = index
    },
    changeSlide (i) {
      this.Item = this.teacher[i]
    },
    login () {
      this.$login(this)
    },
    register () {
      this.$register(this)
    }
  }
}
</script>
<style lang="scss" scoped>
// 轮播图
.banner-box{
  position: relative;
  overflow: hidden;
  .carouse-tem{
    width: 100%;
    height: 520px;
    // background: url('https://qingbo-oss.oss-cn-beijing.aliyuncs.com/19e0791a-1df5-4bf2-8f69-cb0df232c752.png');
    background-image: url('https://qingbo-oss.oss-cn-beijing.aliyuncs.com/6e493d4f-db81-433d-a4ed-671b6c5ce792.png');
    background-repeat: no-repeat;
    background-size: 100% 520px;
    .title{
      padding-left: 100px;
      min-width: 300px;
      font-size: 26rem;
      color: #FFFFFF;
      font-weight: bold;
      line-height: 1.3;
    }
  }
  .login-box{
    height: 520px;
    position: absolute;
    top: 0;
    left: 60%;
    // transform: translateX(-50%);
  }
  .login-btn{
    position: absolute;
    width: 100%;
    display: none;
    text-align: center;
    bottom: 10%;
    // z-index: 200;
    & div{
      text-align: center;
      display: inline-block;
      width: 130px;
      height: 40px;
      line-height: 40px;
      background: #FFFFFF;
      border-radius: 20px;
      color: #00BF86;
      font-size: 16px;
      margin: 0 10px;
    }
  }
}
.contener{
  width: 100%;
  padding: 80px 0;
  .title{
    width: 100%;
    text-align: center;
    h2{
      font-size: 62px;
      color: #24272F;
    }
    p{
      font-size: 24px;
      color: #8E9299;
      letter-spacing: 8px;
    }
  }
}
// 3大选课
.model{
  .tab-box{
    padding-top: 90px;
  }
  .left-tab{
    &:nth-child(odd){
      float: right;
    }
    width: 80%;
    height: 120px;
    background-color: #f9fafc;
    border-radius: 25px;
    padding: 0 25px;
    box-sizing: border-box;
    margin-bottom: 74px;
    cursor: pointer;
    &:last-child{
      margin-bottom: 0px;
    }
    p{
      font-size: 32px;
      color: #B2B4C4;
      margin-right: 20px;
    }
    img{
      width: 10px;
      height: 18px;
    }
  }
  .ph-left-tab{
    width: 30%;
    background-color: #f9fafc;
    box-sizing: border-box;
    margin-right: 1%;
    display: inline-block;
    height: 36px;
    line-height: 36px;
    font-size: 16px;
    border-radius: 25px;
    &:last-child{
      margin-right: 0;
    }
  }
  .tabActiveClass{
    background: linear-gradient(180deg, #00C774 0%, #00C084 100%);
    color: #FFFFFF;
    p{
      color: #FFFFFF;
    }
  }
  .right-tab{
    margin-left: 50px;
    h3{
      color: #24272F;
      font-size: 40px;
    }
    p{
      font-size: 28px;
      color: #8E9299;
      margin-top: 10px;
    }
    img{
      // width: 693px;
      width: 100%;
      height: auto;
      margin-left: 43px;
      margin-top: 80px;
    }
  }
}
// 企业讲师
.teacher-contener{
  background-color: #F9F9FC;
}
// 合作院校
.school{
  padding-top: 130px;
  .img-box{
    width: 100%;
    height: 70px;
    align-items: flex-end;
    margin-bottom: 10px;
  }
  div{
    font-size: 24px;
    span{
      font-size: 40px;
    }
  }
  p{
    font-size: 18px;
    margin-top: 10px;
  }
}

.slider-box{
  ::v-deep{
    .slider-item{
      width: 137px;
    }
  }
}
.login-box{
  h1{
    min-width: 300px;
    font-size: 26rem;
    color: #FFFFFF;
    font-weight: bold;
    line-height: 1.3;
  }
}
.login-btn{
  width: 100%;
  display: none;
  text-align: center;
  & div{
    text-align: center;
    display: inline-block;
    width: 130px;
    height: 40px;
    line-height: 40px;
    background: #FFFFFF;
    border-radius: 20px;
    color: #00BF86;
    font-size: 16px;
    margin: 0 10px;
  }
}
.banner-swiper{
  height: 520px;
  ::v-deep{
    .ivu-carousel-list{
      height: 520px;
    }
  }
}
.tab-ph{
  display: none;
}
@media(max-width: 992px) {
  .login-box{
    height: 360px !important;
  }
  .banner-swiper{
    height: 360px !important;
    .carouse-tem{
      height: 360px !important;
      justify-content: center !important;
      .title{
        padding-left: 0 !important;
      }
    }
    ::v-deep{
      .ivu-carousel-list{
        height: 360px !important;
      }
    }
  }
  .contener{
    padding: 30px 0 !important;
    .title{
      h2{
        font-size: 20px;
      }
      p{
        font-size: 16px;
        letter-spacing: 2px;
      }
    }
  }
  .login,.tab-pc{
    display: none;
  }
  .login-btn,.tab-ph{
    display: block !important;
  }
  .login-box{
    h1{
      text-align: center;
    }
  }
  .right-tab{
    margin-left: 0 !important;
    h3{
      display: none;
    }
    p{
      font-size: 16px !important;
      margin-top: 20px !important;
    }
    img{
      width: 100%;
      margin: 0 !important;
    }
  }
  .model{
    .tab-box{
      padding-top: 30px;
    }
  }
  .school{
    padding-top: 40px;
    .img-box{
      img{
        width: 30px !important;
        height: auto !important;
      }
    }
    div{
      font-size: 16px;
      span{
        font-size: 24px;
      }
    }
    p{
      font-size: 14px;
    }
  }
}

</style>
